import { Field, FieldProps } from "formik";
import * as React from "react";
import { Alert } from "react-bootstrap";
import { FFieldCheckboxI, OptionI } from "../../types";

export const FFieldCheckbox: React.FC<FFieldCheckboxI> = (props) => {
    const {
        label,
        formName,
        options,
        required,
        onChange,
        onBlur,
        labelAppend,
        className,
    } = props;

    return (
        <>
            {options ? (
                <div className={className}>
                    <label className={"form-label d-block"}>
                        {required ? <sup>* </sup> : null}
                        {label}
                        {labelAppend === null ? (
                            ""
                        ) : labelAppend ? (
                            <>{labelAppend}</>
                        ) : (
                            ":"
                        )}
                    </label>

                    <Field name={formName}>
                        {({
                            field, // { name, value, onChange, onBlur }
                            form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                            meta,
                        }: FieldProps) => (
                            <>
                                {options.map((option: OptionI, index) => (
                                    <div
                                        className={
                                            "form-check form-check-inline"
                                        }
                                        key={`ffield-checkbox-option-${option.label}`}
                                    >
                                        <label>
                                            <input
                                                className={"form-check-input"}
                                                type={"checkbox"}
                                                name={field.name}
                                                value={option.value}
                                                checked={field.value.includes(
                                                    option.value
                                                )}
                                                onChange={(e) => {
                                                    form.handleChange(formName)(
                                                        e
                                                    );

                                                    if (onChange) {
                                                        onChange(
                                                            e.currentTarget
                                                                .value
                                                        );
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    form.handleBlur(formName)(
                                                        e
                                                    );
                                                    if (onBlur) {
                                                        onBlur(field.value);
                                                    }
                                                }}
                                                // {...field}
                                            />
                                            {option.label}
                                        </label>
                                    </div>
                                ))}

                                {meta.touched && meta.error && (
                                    <Alert
                                        variant={"warning"}
                                        className={"mt-2"}
                                    >
                                        {meta.error}
                                    </Alert>
                                )}
                            </>
                        )}
                    </Field>
                </div>
            ) : null}
        </>
    );
};
